(function(){
  var BUMP_PRODUCT_ID = 9245066330327;
  var MAIN_PRODUCT_ID = 9206142107863;

  /* Timer for bump UI */
  function initTimers(){
    var els=document.querySelectorAll('[data-ob-timer]');
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(el._t)continue;el._t=true;
      (function(t){
        var s=120;
        var iv=setInterval(function(){
          s--;if(s<=0){clearInterval(iv);var ob=t.closest('.ob');if(ob)ob.style.display='none';return;}
          t.textContent=Math.floor(s/60)+':'+((s%60)<10?'0':'')+(s%60);
          if(s<=30)t.classList.add('ob__countdown--urgent');
        },1000);
      })(el);
    }
  }

  /* Block direct purchase of bump product */
  if(window.location.pathname.indexOf('/products/')>-1){
    fetch(window.location.pathname+'.json').then(function(r){return r.json()}).then(function(d){
      if(d.product&&d.product.id===BUMP_PRODUCT_ID)window.location.href='/';
    }).catch(function(){});
  }

  new MutationObserver(function(){initTimers()}).observe(document.documentElement,{childList:true,subtree:true});
  initTimers();
})();
